/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _matchesSelector = _interopRequireDefault(require("../../../../common/matchesSelector"));
var _containsNode = _interopRequireDefault(require("../../../../common/containsNode"));
function matchesTarget(target, node) {
  if (node === document) {
    return null;
  }
  if (target === node) {
    return true;
  }
  if (typeof target === 'string' && (0, _matchesSelector.default)(node, target)) {
    return true;
  }
  if ((0, _containsNode.default)(target, node)) {
    return true;
  }
  return false;
}
var _default = matchesTarget;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Overlay/src/eventManager/matchesTarget.js
// module id = 728
// module chunks = 0